import IconCheckbox from './IconCheckbox';

export default IconCheckbox;
